import React, { useEffect, useState } from "react";
import { projectCountFilter } from "../../redux/reducers/ProjectCountDisplayStatus";
import { campaignCountFilter } from "../../redux/reducers/CampaignCountDisplayStatus";
import { selectedTask } from "../../redux/reducers/TaskTypeSelected";
import { useDispatch, useSelector } from "react-redux";
import $ from 'jquery';
import Constants from "../../Constants";
import { useTranslation } from "react-i18next";

export default function RadioOptionList(prop) {


  const { t } = useTranslation();
  const translate = t;

  const [radioState, setRadioState] = useState(prop.defaultSelected);
  const [radioName, setRadioName] = useState("");
  const uniqueId = prop.uniqueIDS !== undefined ? prop.uniqueIDS : "";

  const dispatch = new useDispatch();
  const SelectedOption = useSelector((projectCountFilter) => projectCountFilter.project_status_display).value;
  const checkedChildEvent = (e,task) => {
    let checkedVal = "";
    let checkedName = "";
    if (e.keyCode === 13 || e.type === "change") {
      checkedVal = e.target.children[0]?.value;
      checkedName = e.target?.innerText;
      $(e.target).closest('.selection-department').trigger('focus');
      $(e.target).closest('.selection-department').attr('aria-expanded', 'false');
      $(e.target).closest('.popover-body').css('display', 'none');
      $(e.target).closest('.popover-body').prev().find('div').css('display', 'none');
    }
    if (e.type === "click") {
      if (e.target.value !== undefined) {
        checkedVal = e.target.value;
      } else {
        checkedName = e.target.innerText;
      }
    }
    if (checkedVal && checkedVal !== undefined) {
      setRadioState(checkedVal);
    }
    if (checkedName && checkedName !== undefined) {
      setRadioName(checkedName);
    }
  };

  const checkedEvent = (e,id) =>{
    let checkedVal = "";
    let checkedName = "";
    if (e.keyCode === 13 || e.type === "change") {
      checkedVal = e.target.value;
      checkedName = e.target.name;
     // var id = e.target.id

      setTimeout(()=>{
        $(e.target.nextSibling).trigger("focus");
      },1000)
      
    }
    if (e.type === "click") {
      if (e.target.value !== undefined) {
        checkedVal = e.target.value;
      } else {
        checkedName = e.target.name;
      }
    }
    if (checkedVal && checkedVal !== undefined) {
      setRadioState(checkedVal);
    }
    if (checkedName && checkedName !== undefined) {
      setRadioName(checkedName);
    }
    if (e.key = Constants.TAB && !e.shiftKey && $(e.target).closest('.radio-form-check').is(':last-child')) {
      e.preventDefault();
      $(e.target).closest('.selection-department').trigger('focus');
      $(e.target).closest('.selection-department').attr('aria-expanded', 'false');
      $(e.target).closest('.popover-body').css('display', 'none');
      $(e.target).closest('.popover-body').prev().find('div').css('display', 'none');
    }
  }
  useEffect(() => {
    var use = prop.use;

    let id = [{ position: uniqueId }, { data: radioState }];
    let selected_task = [radioState, radioName];
    // uniqueId === '' ? dispatch(selectedTask(selected_task)) : dispatch(projectCountFilter(id)) ;
    if (use === "taskList") {
      if (radioState && radioState !== undefined) {
        dispatch(selectedTask(selected_task));
        setTimeout(()=>{
          $('#circle').trigger('focus')
        },1000)
      }
      if (radioName === "All") {
        dispatch(selectedTask(["ALL","All"]));
        setTimeout(()=>{
          $('#circle').trigger('focus')
        },1000)
      }
      
    }
    if (use === "projectCount") {
      
      dispatch(projectCountFilter(id));
      
    }
    if (use === "campaignCount") {
      dispatch(campaignCountFilter(id));
    }
  }, [radioState, uniqueId, radioName]);

  return (
    <div className="group-radio-list">
      {prop?.taskTypes?.map((task) => {
        return (
          <div
            className="radio-form-check"
            key={task[prop.parmToUse]}
            //tabIndex="0"
            onKeyDown={(e) => {
              checkedChildEvent(e,task);
            }}
            onChange={(e) => {
              checkedChildEvent(e);
            }}
            onClick={(e) => {
              checkedChildEvent(e);
            }}
            
          >
            <input
              type="radio"
              className="form-check-input"
              name={prop.use === "taskList" ? task[prop.parameterToShow] : task[prop.parmToUse] + "_" + uniqueId}
              id={task[prop.parmToUse] + "_" + uniqueId}
              value={task[prop.parmToUse]}
              checked={
                prop.selected === task[prop.parmToUse] ||
                radioState === task[prop.parmToUse]
              }
              onChange={(e) => {
                // checkedEvent(e);
              }}
              onKeyDown={(e) => {
                checkedEvent(e,task[prop.parameterToShow]);
              }}
            />
            <label
              className="form-check-label"
              htmlFor={task[prop.parmToUse] + "_" + uniqueId}
              id={task[prop.parameterToShow]}
            >
             { translate(`select_status.${task[prop.parameterToShow].toLowerCase()}`)}
            </label>
          </div>
        );
      })}
    </div>
  );
}
